import produce from 'immer';
import { SET_CLEAR_CUSTOMER } from 'containers/WorkQueue/constants';
import { SET_AGREEMENTS_DETAILS, SET_MASTER_DATA } from './constants';

export const initialState = {
  agreementDetails: { data: [] },
  masterData: {
    loanPurpose: [],
    loanType: [],
    logoCode: [],
    programTypes: [],
    status: false,
  },
};

const reducer = (state = initialState, { type, payload }: any) =>
  produce(state, (draft: any) => {
    switch (type) {
      case SET_AGREEMENTS_DETAILS:
        draft.agreementDetails = payload;
        break;
      case SET_MASTER_DATA:
        draft.masterData.loanPurpose = payload.loanPurpose ?? [];
        draft.masterData.loanType = payload.loanType ?? [];
        draft.masterData.logoCode = payload.logoCode ?? [];
        draft.masterData.programTypes = payload.programTypes ?? [];
        draft.masterData.status = true;
        break;
      case SET_CLEAR_CUSTOMER:
        draft.agreementDetails = initialState.agreementDetails;
        break;
      default: {
        break;
      }
    }
  });

export default reducer;
